<template>
  <modal
    name="create-financial-row"
    transition="pop-out"
    :classes="'modal fade show'"
    :height="modalHeight"
    :resizable="false"
    :pivot-y="0.05"
    @before-open="beforeOpen"
  >
    <div class="modal-dialog ui-block window-popup create-event">
      <a
        href="#"
        class="close icon-close"
        aria-label="Close"
        @click="$modal.hide('create-financial-row')"
      >
        <app-icon
          name="olymp-close-icon"
          color="black"
          size="small"
        />
      </a>
      <!--<flash-message class="fl-msg"></flash-message>-->
      <div class="fl-msg" />

      <div
        v-if="date"
        class="ui-block-title"
      >
        <h6 class="title">
          Financial Row
        </h6>
      </div>

      <div class="ui-block-content">
        <form
          class="content"
          @submit.prevent="addRow"
        >
          <div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12">
              <p><strong>Date</strong></p>
              <datepicker
                :value="date"
                class="form-group label-floating"
                @selected="dateSelected"
              />
            </div>

            <div class="col-xl-12 col-lg-12 col-md-12">
              <p><strong>Category</strong></p>
              <select
                v-model="item.cat_id"
                class="form-group has-bootstrap-select "
              >
                <option :value="''">
                  Choose Category
                </option>
                <option
                  v-for="option in categories"
                  :key="option.id"
                  :value="option.id"
                >
                  {{ option.name }}
                </option>
              </select>
            </div>

            <div class="col-xl-12 col-lg-12 col-md-12">
              <p><strong>Description</strong></p>
              <textarea
                v-model="item.description"
                rows="5"
                class="form-control label-floating"
              />
            </div>

            <div class="col-xl-12 col-lg-12 col-md-12">
              <p><strong>Price</strong></p>
              <input
                v-model="item.price"
                class="form-group label-floating"
              >
            </div>

            <div class="col-xl-12 col-lg-12 col-md-12">
              <label>
                <input
                  v-model="item.flag_recurrent"
                  type="checkbox"
                >
                <strong>Is recurrent</strong>
              </label>
            </div>

            <div
              v-if="item.flag_recurrent"
              class="col-xl-12 col-lg-12 col-md-12"
            >
              <p><strong>Recurrent Type</strong></p>
              <select
                v-model="recurrent_type"
                class="form-group has-bootstrap-select "
                @change="changeType"
              >
                <option :value="''">
                  Choose Type
                </option>
                <option
                  v-for="option in recTypes"
                  :key="option.key"
                  :value="option.key"
                >
                  {{ option.name }}
                </option>
              </select>
            </div>

            <div
              v-if="item.flag_recurrent && recurrent_type"
              class="col-xl-12 col-lg-12 col-md-12"
            >
              <p><strong>Recurrent Item</strong></p>
              <select
                v-model="recurrent_item"
                class="form-group has-bootstrap-select "
              >
                <option value="''">
                  Choose Recurrent Item
                </option>
                <option
                  v-for="option in availableRec"
                  :key="option.id"
                  :value="option.id"
                >
                  {{ option.name }}
                </option>
              </select>
            </div>

            <button
              class="btn btn-lg btn-breez full-width mt-4"
              type="submit"
              name="submit"
            >
              <span>{{ item.id ? 'Edit' : 'Add' }} Row</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </modal>
</template>

<script>
// import VModal from 'vue-js-modal'
import VModal from 'vue-js-modal';
import Vue from 'vue'
Vue.use(VModal, {dialog: true});
import { mapState } from 'vuex'
import Datepicker from 'vuejs-datepicker'
import {EventBus} from "../../../event-bus";

const MODAL_HEIGHT = 800

import AppIcon from "../../common-apps/common/AppIcon"

export default {
  name: 'AddFinancialRow',
  components: { Datepicker, AppIcon },
  data () {
    return {
      modalHeight: MODAL_HEIGHT,
      item: {
        cat_id: '',
        description: '',
        price: '',
      },
      recurrent_type: '',
      recurrent_item: '',
      oldItem: {},
      date: new Date()
    }
  },
  computed: mapState({
    categories: state => state.financial.categories,
    recurrences: state => state.financial.recurrences,
    recTypes: state => state.financial.recTypes,
    itemsRec: state => state.financial.itemsRec,
    availableRec: state => state.financial.availableRec
  }),
  created () {
    this.modalHeight = window.innerHeight < MODAL_HEIGHT
      ? MODAL_HEIGHT - 200
      : MODAL_HEIGHT

    EventBus.$on('close-modal', () => {
      this.$modal.hide('create-financial-row')
    })
  },
  methods: {
    changeType() {
      this.$store.dispatch('financial/getAvailableRecurrences', {type: this.recurrent_type, item: this.oldItem.recurrent_item ?? ''})
    },
    dateSelected (date) {
      this.date = date
    },
    beforeOpen (event) {
      this.$store.dispatch('financial/getCat')
      let opts = { recTypes: this.recurrencyTypes};
      if (event.params.item) {
        this.item = event.params.item
        this.oldItem = Object.assign({}, event.params.item)
        opts.include_type = ''
        if (event.params.item.FiRecurrencies && event.params.item.FiRecurrencies.length > 0) {
          this.recurrent_type = event.params.item.FiRecurrencies[0].type;
          this.recurrent_item = event.params.item.FiRecurrencies[0].id;
          this.$store.dispatch('financial/getAvailableRecurrences', {type: this.recurrent_type, item: this.recurrent_item})

          this.oldItem.recurrent_item = this.recurrent_item;
          this.oldItem.recurrent_type = this.recurrent_type;
          opts.include_type = this.recurrent_type;
          // opts.include_item = this.recurrent_item;
        }
        this.date = new Date(event.params.item.date)
      }
      this.$store.dispatch('financial/getRecTypes', opts)
    },
    // eslint-disable-next-line
      addRow: function() { // !!!! this messes up if I use arrow function
      const payload = this.item
      payload.date = this.date
      if (this.item.id) {
        if (!this.item.flag_recurrent) {
          this.recurrent_type = ''
          this.recurrent_item = ''
        }
        this.$store.dispatch('financial/edit', { payload, oldItem: this.oldItem, recurrent_item: this.recurrent_item, recurrent_type: this.recurrent_type })
      } else {
        this.$store.dispatch('financial/add', { payload, recurrent_item: this.recurrent_item, recurrent_type: this.recurrent_type  })
      }
    }
  }
}
</script>
